document.addEventListener('DOMContentLoaded', () => {
  const notify = document.querySelector('cart-notification');
  const onCartPage = Boolean(document.querySelector('cart-items'));

  document.querySelectorAll('.product-card-buy').forEach((button) => {
    button.addEventListener('click', (evt) => {
      if (button.classList.contains('no-stock')) return;

      evt.preventDefault();
      const variantId = button.dataset.variantId;
      const productCard = button.closest('a.product-card');

      if (!onCartPage) {
        notify?.style.setProperty(
          '--offset',
          `${document.querySelector('.shopify-section-group-header-group')?.getBoundingClientRect().height || 0}px`
        );
      }

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.status) {
            console.error('Error adding to cart:', json.description);
            return;
          }

          if (onCartPage) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-card',
              cartData: json,
              variantId: variantId,
            });
            return;
          }

          notify?.renderContents(
            productCard?.querySelector('.product-card-img img'),
            productCard?.querySelector('.product-card-title')
          );
        })
        .catch((err) => {
          console.error('Error adding to cart:', err);
        });
    });
  });
});
